var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2081_38475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 9.89774C16 9.40167 15.5523 8.99952 15 8.99951H3C2.44772 8.99951 1.99998 9.40167 1.99998 9.89774V15.287C1.99999 15.783 2.44772 16.1852 3 16.1852H15C15.5523 16.1851 16 15.783 16 15.287V9.89774ZM18 15.287C18 16.7751 16.6568 17.9816 15 17.9816H3C1.34315 17.9816 5.44276e-06 16.7751 0 15.287V9.89774C0 8.40954 1.34315 7.20312 3 7.20312H15C16.6568 7.20313 18 8.40955 18 9.89774V15.287Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.10141V5.4068C12.5 4.1479 12.3587 3.28675 11.9286 2.7305C11.5628 2.25738 10.8238 1.81397 8.99999 1.81397C7.17619 1.81397 6.43715 2.25738 6.07136 2.7305C5.6413 3.28675 5.49998 4.1479 5.49998 5.4068V8.10141C5.49998 8.59747 5.05227 8.99961 4.49999 8.99961C3.94771 8.99961 3.50001 8.59747 3.5 8.10141V5.4068C3.5 4.15074 3.60868 2.76636 4.42862 1.70584C5.31283 0.562199 6.82379 0.0175781 8.99999 0.0175781C11.1762 0.0175781 12.6872 0.562199 13.5714 1.70584C14.3913 2.76636 14.5 4.15074 14.5 5.4068V8.10141C14.5 8.59747 14.0523 8.99961 13.5 8.99961C12.9477 8.99961 12.5 8.59747 12.5 8.10141Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2081_38475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSvgrepoCom1);
export default __webpack_public_path__ + "static/media/lock-svgrepo-com 1.6767459bc6600d082019dcd14c60f2a7.svg";
export { ForwardRef as ReactComponent };